<template>
    <div class="flex" v-if="$route.meta.showTabBar">
        <router-link class="tabbar-item" :to="item.path" replace v-for="item in tabBars" :key="item.path">
            <img :class="{ 'active-pic': currentPath === item.path }" :src="item.activeUrl"
                v-if="currentPath === item.path" />
            <img :src="item.url" alt="" v-else />
            <span :class="{ active: currentPath === item.path }">
                {{ item.menuName }}
            </span>
        </router-link>
    </div>
</template>

<script>
import localStorage from '@/utils/localStorage.js'

export default {
    name: 'TabBar',
    data() {
        return {
            roleType: '',
            active: 0,
            tabBars: [{
                path: '/home',
                url: require('@/assets/icons/home-icon.png'),
                activeUrl: require('@/assets/icons/active-home.png'),
                menuName: '首页'
            },
            
            {
                path: '/mine',
                url: require('@/assets/icons/mine-icon.png'),
                activeUrl: require('@/assets/icons/active-mine.png'),
                menuName: '我的'
            },],
            associationTabBars: [{
                path: '/associationHome',
                url: require('@/assets/icons/rest-icon.png'),
                activeUrl: require('@/assets/icons/active-rest-icon.png'),
                menuName: '请假情况'
            },
            {
                path: '/approvalTask',
                url: require('@/assets/icons/approval-icon.png'),
                activeUrl: require('@/assets/icons/active-approval-icon.png'),
                menuName: '审批任务'
            },]
        }
    },
    created() {
        let role = localStorage.get("role");
        let realRole = "";
        if (role){
            realRole = role.toString().replaceAll('"','');
        }
        this.roleType = realRole;
        this.tabBars = this.roleType == 'OPENID_BIND_TYPE_EXPERT' ? this.tabBars : this.associationTabBars
    },
    computed: {
        currentPath() {
            return this.$route.path;
        }
    }
}
</script>
<style lang="scss" scoped>
.tabbar-item {
    flex: 1;

    img {
        width: 40px;
        height: 40px;
        display: block;
        margin: 15px auto 5px auto;
    }

    span {
        font-size: 20px;
        font-family: 'PingFang SC';
        text-align: center;
        display: block;
        color: #444444;

        &.active {
            color: #1A66FF;
        }
    }

    &:first-of-type {
        img {

            width: 40px;
            height: 40px;
            display: block;

            &.active-pic {
                width: 40px;
                height: 40px;
            }
        }

        span {
            font-size: 20px;
            font-family: 'PingFang SC';
            text-align: center;
            display: block;
        }
    }
}

.flex {
    position: fixed;
    left: 0px;
    bottom: 0px;
    width: 100%;
    height: 100px;
    background-color: #fff;
    z-index: 9999;
}
</style>
